<template>
    <div class="design-3 floor-wsw" :id="data.block_name + c_index">
        <div class="head-wrap" v-if="data.value.title.value.text">
            <div class="left-head-warp">
                <el-image @click="$router.pushToTab(data.value.more.value.link.url)" 
                :src="$img(data.value.titleImg.value.url)" fit="scale-down"></el-image>
                <h2 @click="$router.pushToTab(data.value.title.value.link.url)" :style="{ color: data.value.title.value.color }">
                    {{ data.value.title.value.text }}
                </h2>
                <span class="warp-title" :style="{ color: data.value.subTitle.value.color }" @click="$router.pushToTab(data.value.subTitle.value.link.url)">
                    {{ data.value.subTitle.value.text }}
                </span>
            </div>
            <div class="right-head-warp">
                <div @click="$router.pushToTab(data.value.more.value.link.url)" :style="{ color: data.value.more.value.color }">
                    <span :style="{ color: data.value.more.value.color }">{{ data.value.more.value.text }}</span>
                    <i :style="{ color: data.value.more.value.color }" class="icon el-icon-arrow-right"></i>
                </div>
            </div>
        </div>
        <div class="design-3-body-wrap">
            <div class="wrp-l">
                <img :src="$img(data.value.leftImg.value.url)" @click="$router.pushToTab(data.value.leftImg.value.link.url)" />
            </div>
            <div class="wrp-c">
                <template v-for="(item, index) in data.value.goodsList.value.list">
                    <div class="hoverBox hoverBoder">
                        <goodsListItem imageSize="100" :goods="item" :upDownLayout="true" :isRow="true"></goodsListItem>
                    </div>
                </template>
            </div>
            <div class="wrp-r">
                <img :src="$img(data.value.rightImg.value.url)" @click="$router.pushToTab(data.value.rightImg.value.link.url)" />
            </div>
        </div>
    </div>
</template>

<script>
import shareCounter from "@/components/shareCounter.vue"
import { mapGetters } from "vuex"
import { onTip } from "@/utils/tips"
import ctrlShowText from "@/components/ctrl-show-text/ctrl-show-text.vue";
import goodsPrice from '@/components/goods-price/goods-price.vue'
import GoodsListItem from "@/components/goods-list-item/goods-list-item.vue"
export default {
    name: "floor-style-ermei-design-3",
    components: {
        shareCounter,
        ctrlShowText,
        goodsPrice,
        GoodsListItem
    },
    props: {
        data: {
            type: Object
        },
        c_index: {
            type: Number
        }
    },
    data() {
        return {
            number: 0
        }
    },
    computed: {
        ...mapGetters(["defaultGoodsImage", "cartCount", "siteInfo", "member"]),
        logined: function () {
            return this.member !== undefined && this.member !== "" && this.member != {}
        }
    },
    methods: {
        upnumber(val) {
            this.number = val
        },
        goSku(item) {
            if (!this.$store.getters.token) {
                this.$router.pushToTab("/login")
                return
            }
            if (onTip(item.sale_control.view_price, item.sale_control.is_member_by, this, item.sale_control.not_buy_msg)) return
            this.$router.pushToTab("/sku-" + item.sku_id)
        },
        imageError(index) {
            this.data.value.goodsList.value.list[index].goods_image = this.defaultGoodsImage
        },
        // 加入购物车
        joinCart(item,index) {
            if (onTip(item.sale_control?.view_price, item.sale_control?.is_member_by, this, item.sale_control?.not_buy_msg)) return
            this.$store
                .dispatch("cart/add_to_cart", {
                    site_id: item.site_id,
                    sku_id: item.sku_id,
                    num: this.number
                })
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "加入购物车成功",
                            type: "success"
                        })
                    }
                })
                .catch(err => {
                    if (err.message === "token不存在") {
                        this.$router.pushToTab("/login")
                    } else {
                        this.$message.error(err.message);
                        if(typeof err.data === 'number'){
                            if(err.data > 0){
                                this.$refs['shareCounter'+index][0].upnumber(err.data);
                                this.$message({
                                    message: "当前数量已更改为可购买数量，请重试加入购物车",
                                    type: "success"
                                });
                            }else{
                                window.location.reload();
                            }
                        }
                    }
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.design-3 {
    background: #fff;
    margin-top: 20px;

    .head-wrap {
        height: 50px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #f9f9f9;
    }

    .head-wrap {
        .left-head-warp {
            text-align: center;
            display: flex;
            align-items: center;
            .el-image {
                width: 30px;
                height: 30px;
            }

            .warp-title {
                margin-left: 10px;
            }

            h2 {
                margin-left: 10px;
                display: inline-block;
                vertical-align: middle;
                text-align: center;
                font-size: 18px;
                line-height: 30px;
                cursor: pointer;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        span {
            color: #b0b0b0;
            font-size: 14px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .el-icon-arrow-right {
            font-size: 16px;
        }
    }

    &-body-wrap {
        padding: 12px 0;
        display: flex;
        box-sizing: border-box;
        .wrp-l {
            cursor: pointer;
            width: 255px;
            flex-shrink: 0;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            img {
                max-width: 100%;
                max-height: 100%;
                flex-shrink: 0;
                cursor: pointer;
            }
        }

        .wrp-c {
            display: flex;
            flex-wrap: wrap;
            gap: 12px;
            padding: 0 12px;
            box-sizing: border-box;
            >div{
                width: calc((100% - 12px) / 2);
                border: 1px solid #f9f9f9;
                box-sizing: border-box;
                border-radius: 12px;
                box-sizing: border-box;
                padding: 12px;
                transition: all 0.2s linear;
                &:hover {
                    z-index: 2;
                    -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                    -webkit-transform: translate3d(0, -2px, 0);
                    transform: translate3d(0, -2px, 0);
                }
            }
        }

        .wrp-r {
            cursor: pointer;
            width: 255px;
            flex-shrink: 0;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            img {
                max-width: 100%;
                max-height: 100%;
                flex-shrink: 0;
                cursor: pointer;
            }
        }
    }
}
</style>